import { Button, EmptyState } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'common/hooks/useTranslation';
import { getHelpCenterBase } from 'common/utils/help-center/getHelpCenterBase';
import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { routeFor, routes } from 'src/core/constants/routes';

export const PayableRuleEmptyState = ({
  openModal,
}: {
  openModal: () => void;
}) => {
  const { activeLanguage, t } = useTranslation('global');
  const history = useHistory();
  const companyId = useCompanyId();

  const helpCenterLink = `${getHelpCenterBase({
    lang: activeLanguage,
  })}articles/11100945`;

  return (
    <EmptyState
      className="mt-64"
      title={t('bookkeep.integrations.settings.payableRules.emptyState.title')}
      subtitle={t(
        'bookkeep.integrations.settings.payableRules.emptyState.subtitle',
      )}
      iconName="lightning"
      iconVariant="purple"
      actions={[
        <Button
          key="helpCenter"
          onClick={() => {
            window.open(helpCenterLink, '_blank', 'noopener,noreferrer');
          }}
          variant="tertiaryNeutral"
          text={t('bookkeep.integrations.settings.payableRules.helpCenter')}
          iconName="arrow-top-right-square"
          iconPosition="right"
        />,
        <Button
          key="tour"
          onClick={openModal}
          variant="secondaryNeutral"
          text={t('bookkeep.integrations.settings.payableRules.tour.label')}
        />,
        <Button
          key="create"
          onClick={() => {
            history.push(
              routeFor(routes.COMPANY_ACCOUNTING_PAYABLE_RULES_SETUP.path, {
                company: companyId,
                payableRuleId: 'new',
              }),
            );
          }}
          variant="primaryBrand"
          text={t('bookkeep.integrations.settings.payableRules.create')}
        />,
      ]}
    />
  );
};
